import axios from 'axios';
import { local } from '../utils/constants';

const serverBaseUrl = local ? "http://127.0.0.1:8000" : "https://backend.withsix.co";

const api= axios.create({
    baseURL: serverBaseUrl
}); 

export default api;